import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { from, of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { InteractionRequiredAuthError, RedirectRequest, SilentRequest } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { PublicRequestService, publicRoutes } from '../services/public-request.service';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public readonly scopes = [
    'https://identity.cafler.com/my-identity/Business.Identity',
    'https://identity.cafler.com/my-identity/Business.Services',
    'https://identity.cafler.com/my-identity/Account.Identity',
  ];
  // publicPath: boolean = false;

  constructor(private msalService: MsalService, private PublicRequestService: PublicRequestService, private router: Router, private LocalStorageService: LocalStorageService) {
    // this.router.events
    //   .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
    //   .subscribe(event => {
    //     const currentUrl = event.urlAfterRedirects;
    //     this.publicPath = publicRoutes.some(route => currentUrl.startsWith(route));
    //   });
  }

  login() {
    const loginRequest: RedirectRequest = {
      scopes: this.scopes,
    };
    this.msalService.loginRedirect(loginRequest);
  }

  logout(): void {
    this.LocalStorageService.clear()
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: '/home',
    });
  }

  isLoggedIn(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  // private async acquireTokenSilent(scopes: string[]): Promise<string | undefined> {
  //   const account = this.msalService.instance.getAllAccounts()[0];
  //   if (!this.publicPath && !account) {
  //     console.error('No user account found');
  //     this.logout();
  //     return undefined;
  //   }

  //   const silentRequest: SilentRequest = {
  //     scopes: scopes,
  //     account: account,
  //   };

  //   try {
  //     const response = await from(this.msalService.acquireTokenSilent(silentRequest))
  //       .pipe(
  //         map((response) => {
  //           if (!response.accessToken) {
  //             throw new Error('Token is undefined');
  //           }
  //           return response.accessToken;
  //         }),
  //         catchError((error) => {
  //           console.error('Failed to acquire token silently', error);
  //           if (error instanceof InteractionRequiredAuthError) {
  //             this.msalService.acquireTokenRedirect(silentRequest as RedirectRequest);
  //           }
  //           return of(undefined);
  //         })
  //       )
  //       .toPromise();

  //     if (!response) {
  //       console.error('There is no response');
  //       return undefined;
  //     }

  //     return response;
  //   } catch (error: any) {
  //     console.error('Error getting access token', error);
  //     if (error.errorCode === 'interaction_in_progress') {
  //       console.error('Interaction is currently in progress, please try again later.');
  //       return undefined;
  //     }
  //     if (!this.publicPath) {
  //       this.logout();
  //     }
  //     return undefined;
  //   }
  // }

  // public async getAccessToken(): Promise<string | undefined> {
  //   const token = await this.acquireTokenSilent(this.scopes);
  //   if (!token) {
  //     console.error('Failed to retrieve bearer token');
  //     if (!this.publicPath) {
  //       this.logout();
  //     }
  //     return undefined;
  //   }
  //   return token;
  // }

  changePassword(): void {
    const resetPasswordRequest: RedirectRequest = {
      authority: environment.azureActiveDirectory.authority,
      scopes: ['https://identity.cafler.com/my-identity/Business.Identity'],
    };

    this.msalService.loginRedirect(resetPasswordRequest);
  }
}
